module.exports = __webpack_public_path__ + "img/Logo.8da5bd97.png";